import React from 'react';

import Button from '../../Shared/UI/Button/components/Button';
import EditPencilIcon from '../../Shared/UI/EditPencilIcon/components/EditPencilIcon';
import TrashCanIcon from '../../Shared/UI/TrashCanIcon/components/TrashCanIcon';

import { useProfileState, useProfileActions } from './ProfileContext';

import styles from './ProfileUserCertification.module.scss';

const dateLineText = (certification) => {
  const obtained = certification.dateObtained;
  const expiration = certification.expirationDate;

  if (obtained && expiration) {
    return `Obtained ${obtained} · Expires ${expiration}`;
  }

  if (obtained) {
    return `Obtained ${obtained}`;
  }

  if (expiration) {
    return `Expires ${expiration}`;
  }

  return null;
};

const ProfileUserCertification = ({ certification }) => {
  const profileState = useProfileState();
  const { openUpdateUserCertificationModal, openDeleteUserCertificationModal } = useProfileActions();
  const dateLine = dateLineText(certification);

  return (
    <div key={certification.id} className={styles.userCertification}>
      <div className={styles.userCertificationTitleContainer}>
        <p className={styles.title}>{certification.name}</p>
        {profileState?.user?.isAuthenticatedUser && (
          <div className={styles.buttonContainer}>
            <Button
              variant="ghost"
              icon={<EditPencilIcon />}
              iconOnly
              aria-label="Edit Certification"
              onClick={() => {
                if (profileState?.user?.isAuthenticatedUser) {
                  openUpdateUserCertificationModal(certification);
                }
              }}
            />
            <Button
              variant="ghost"
              icon={<TrashCanIcon />}
              iconOnly
              aria-label="Delete Certification"
              onClick={() => {
                if (profileState?.user?.isAuthenticatedUser) {
                  openDeleteUserCertificationModal(certification);
                }
              }}
            />
          </div>
        )}
      </div>
      {certification.issuingOrganization && (
        <p className={styles.issuingOrganization}>{certification.issuingOrganization}</p>
      )}
      {dateLine && (
        <p className={styles.dates}>{dateLine}</p>
      )}
      {certification.credentialId && (
        <p className={styles.credentialId}>Credential ID: {certification.credentialId}</p>
      )}
    </div>
  );
};

export default ProfileUserCertification;
